import styled from "styled-components";
import { ReactComponent as IconDownload } from "../Images/icon_download.svg";
import { ReactComponent as IconMemberSetting } from "../Images/icon_member_setting.svg";
import { ReactComponent as IconMemberDepartment } from "../Images/icon_member_department.svg";

const MemberManageActionBar = ({
  totalMember,
  clickAndEdit,
  userIdCount,
  isExcelDownloadDisabled,
  canManageDepartmentAndRelation,
  clickActive,
  onDownloadExcel,
  onOpenDepartmentModal,
  onStartSelectionEdit,
  onCancelSelectionEdit,
  onDeactivateSelected,
  onDeleteSelected,
  onActivateSelected,
}) => {
  return (
    <ManageToolbar>
      <div>전체 {totalMember?.toLocaleString()}건</div>
      {clickAndEdit && <div>&nbsp;/ 선택 {userIdCount}건</div>}
      {!clickAndEdit && (
        <>
          <ExcelDownloadAction $isDisabled={isExcelDownloadDisabled}>
            <DownloadIcon />
            <ExcelDownloadLabel
              $isDisabled={isExcelDownloadDisabled}
              onClick={isExcelDownloadDisabled ? undefined : onDownloadExcel}
              aria-disabled={isExcelDownloadDisabled}
            >
              엑셀 다운로드
            </ExcelDownloadLabel>
          </ExcelDownloadAction>
          {canManageDepartmentAndRelation && (
            <ToolbarButton
              $gap="4px"
              $marginLeft="8px"
              $color="#1167ED"
              $boxShadow="none"
              $border="1px solid transparent"
              $backgroundColor="rgba(17, 103, 237, 0.15)"
              onClick={onOpenDepartmentModal}
            >
              <IconMemberDepartment />
              부서 관리
            </ToolbarButton>
          )}
        </>
      )}

      {clickAndEdit ? (
        <ToolbarActions>
          {clickActive ? (
            <ToolbarButton
              $backgroundColor="#1167ed"
              $boxShadow="none"
              $color="#ffffff"
              onClick={onDeactivateSelected}
            >
              비활성화
            </ToolbarButton>
          ) : (
            <ToolbarActionsGroup>
              <ToolbarButton
                $color="#f25c5c"
                $boxShadow="inset 0 0 0 1px #f25c5c"
                onClick={onDeleteSelected}
              >
                탈퇴
              </ToolbarButton>
              <ToolbarButton
                $backgroundColor="#1167ed"
                $boxShadow="none"
                $color="#ffffff"
                $marginLeft="8px"
                onClick={onActivateSelected}
              >
                활성화
              </ToolbarButton>
            </ToolbarActionsGroup>
          )}
          <ToolbarButton $marginLeft="8px" onClick={onCancelSelectionEdit}>
            선택 편집 취소
          </ToolbarButton>
        </ToolbarActions>
      ) : (
        <ToolbarButton
          $gap="4px"
          $marginLeft="8px"
          $border="1px solid #D2D2D2"
          $boxShadow="none"
          onClick={onStartSelectionEdit}
        >
          <IconMemberSetting />
          선택 편집
        </ToolbarButton>
      )}
    </ManageToolbar>
  );
};

const ManageToolbar = styled.div.attrs({ className: "hrz-wrapper" })`
  margin-top: 18px;
  height: 43px;
`;

const ToolbarActions = styled.div`
  margin-left: auto;
  display: flex;
`;

const ToolbarActionsGroup = styled.div`
  display: flex;
`;

const ExcelDownloadAction = styled.div`
  display: flex;
  margin-left: auto;
  opacity: ${(props) => (props.$isDisabled ? 0.45 : 1)};
`;

const DownloadIcon = styled(IconDownload)`
  margin-top: 3px;
  margin-right: 4px;
`;

const ExcelDownloadLabel = styled.div`
  color: ${(props) => (props.$isDisabled ? "#8f8f8f" : "#1167ed")};
  margin-right: 8px;
  cursor: ${(props) => (props.$isDisabled ? "default" : "pointer")};
`;

const ToolbarButton = styled.div.attrs({ className: "checkAndEdit-Btn" })`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.$gap ?? "0"};
  margin-left: ${(props) => props.$marginLeft ?? "0"};
  color: ${(props) => props.$color ?? "#222222"};
  box-shadow: ${(props) =>
    props.$boxShadow ?? "inset 0 0 0 1px #222222"};
  border: ${(props) => props.$border ?? "none"};
  background-color: ${(props) => props.$backgroundColor ?? "transparent"};
`;

export default MemberManageActionBar;
